/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingCancellationRefundEligibilityDto } from '../models/BookingCancellationRefundEligibilityDto';
import type { BookingMeetingDto } from '../models/BookingMeetingDto';
import type { BookingWithStripeLineItemEntity } from '../models/BookingWithStripeLineItemEntity';
import type { CustomerMultipassEntity } from '../models/CustomerMultipassEntity';
import type { GetOrderPaymentInstructionsDto } from '../models/GetOrderPaymentInstructionsDto';
import type { OrderEntity } from '../models/OrderEntity';
import type { PatchBookingDto } from '../models/PatchBookingDto';
import type { PostCancellationDto } from '../models/PostCancellationDto';
import type { PublicBookingEntity } from '../models/PublicBookingEntity';
import type { PublicRebateCodeEntity } from '../models/PublicRebateCodeEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PaymentCustomerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get orders
     * @returns OrderEntity The Orders have been returned
     * @throws ApiError
     */
    public paymentCustomerControllerGetOrdersV1(): CancelablePromise<Array<OrderEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/payment/order',
        });
    }
    /**
     * Get an Order
     * @param orderId
     * @returns OrderEntity The Order has been returned
     * @throws ApiError
     */
    public paymentCustomerControllerGetOrderV1(
        orderId: string,
    ): CancelablePromise<OrderEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/payment/order/{orderId}',
            path: {
                'orderId': orderId,
            },
            errors: {
                404: `The Order has not been found`,
            },
        });
    }
    /**
     * Get Order payment instructions
     * @param orderId
     * @returns GetOrderPaymentInstructionsDto The payment instructions for the Order have been returned
     * @throws ApiError
     */
    public paymentCustomerControllerGetOrderPaymentInstructionsV1(
        orderId: string,
    ): CancelablePromise<GetOrderPaymentInstructionsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/payment/order/{orderId}/payment-instructions',
            path: {
                'orderId': orderId,
            },
            errors: {
                404: `The Order has not been found`,
            },
        });
    }
    /**
     * Get the Bookings of an Order
     * @param orderId
     * @returns BookingWithStripeLineItemEntity The Bookings of the Order have been returned
     * @throws ApiError
     */
    public paymentCustomerControllerGetOrderBookingsV1(
        orderId: string,
    ): CancelablePromise<Array<BookingWithStripeLineItemEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/payment/order/{orderId}/bookings',
            path: {
                'orderId': orderId,
            },
            errors: {
                404: `The Order has not been found`,
            },
        });
    }
    /**
     * Change Booking details
     * @param bookingId
     * @param requestBody
     * @returns PublicBookingEntity The Booking details have been changed
     * @throws ApiError
     */
    public paymentCustomerControllerPatchBookingV1(
        bookingId: string,
        requestBody: PatchBookingDto,
    ): CancelablePromise<PublicBookingEntity> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/customer/payment/booking/{bookingId}',
            path: {
                'bookingId': bookingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `The Booking has not been found`,
            },
        });
    }
    /**
     * Get useable Multipasses that can be applied to the bookings of the Order
     * @param orderId
     * @returns CustomerMultipassEntity The Multipasses have been returned
     * @throws ApiError
     */
    public paymentCustomerControllerGetUseableMultipassesForOrderV1(
        orderId: string,
    ): CancelablePromise<Array<CustomerMultipassEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/payment/order/{orderId}/useableMultipasses',
            path: {
                'orderId': orderId,
            },
            errors: {
                404: `The Order has not been found`,
            },
        });
    }
    /**
     * Get useable Rebate Codes that can be applied to the Order or Bookings of the Order
     * @param orderId
     * @returns PublicRebateCodeEntity The Rebate Codes have been returned
     * @throws ApiError
     */
    public paymentCustomerControllerGetUseableRebateCodesForOrderV1(
        orderId: string,
    ): CancelablePromise<Array<PublicRebateCodeEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/payment/order/{orderId}/useableRebateCodes',
            path: {
                'orderId': orderId,
            },
            errors: {
                404: `The Order has not been found`,
            },
        });
    }
    /**
     * Get Meetings of all Bookings with Info about booking and order
     * @returns BookingMeetingDto The cancellation refund eligibility has been returned
     * @throws ApiError
     */
    public paymentCustomerControllerGetBookingMeetingsV1(): CancelablePromise<Array<BookingMeetingDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/payment/booking/meetings',
        });
    }
    /**
     * Get cancellation refund eligibility of a Booking
     * @param bookingId
     * @returns BookingCancellationRefundEligibilityDto The cancellation refund eligibility has been returned
     * @throws ApiError
     */
    public paymentCustomerControllerGetBookingCancellationRefundEligibilityV1(
        bookingId: string,
    ): CancelablePromise<BookingCancellationRefundEligibilityDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/payment/booking/{bookingId}/cancel',
            path: {
                'bookingId': bookingId,
            },
            errors: {
                404: `The Booking has not been found`,
            },
        });
    }
    /**
     * Cancel a Booking and trigger a refund if eligible
     * @param bookingId
     * @param requestBody
     * @returns PublicBookingEntity The Booking has cancelled and returned
     * @throws ApiError
     */
    public paymentCustomerControllerCancelBookingAndRefundIfEligibleV1(
        bookingId: string,
        requestBody: PostCancellationDto,
    ): CancelablePromise<PublicBookingEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/customer/payment/booking/{bookingId}/cancel',
            path: {
                'bookingId': bookingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `The Booking has not been found`,
            },
        });
    }
}
